// extracted by mini-css-extract-plugin
export default {"row":"summary-row_row__ss8G3","card":"summary-row_card__mx8W9"};